import type { AppShellPanelDefaults } from '@efficiently/client-ui-app-shell';

import { AI_CHAT_BUTTON_ID } from './app-rail-buttons.constant';

/**
 * What the section a session starts in seeds the shell's shared `(open, activeButtonId)` pair with
 * (BR-4).
 *
 * The keys are the section ids `APP_SECTIONS` already uses.
 *
 * A default belongs here for every section that CAN be enabled, not only for the ones the base
 * `APP_SECTIONS` table ships enabled — a section's `enabled` flag is what decides whether it is
 * reachable, and that decision is not this table's to anticipate. This file is reached only from the
 * build that HAS the Control Center — the plain one registers no defaults at all, having no panel.
 */
export const PANEL_DEFAULTS: AppShellPanelDefaults = {
	'control-center': { open: true, buttonId: AI_CHAT_BUTTON_ID },
	design: { open: true, buttonId: AI_CHAT_BUTTON_ID },
	build: { open: true, buttonId: AI_CHAT_BUTTON_ID },
	'client-portal': { open: false },
	supply: { open: true, buttonId: AI_CHAT_BUTTON_ID },
};
